import { render, staticRenderFns } from "./TriggersMatrix.vue?vue&type=template&id=018ad530&"
import script from "./TriggersMatrix.vue?vue&type=script&lang=ts&"
export * from "./TriggersMatrix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports